export default "__VITE_ASSET__rVnV3Ccg__"